import { Flex, Text } from "@capioweb/ui-components/src"
import React from "react"
import { useQuery } from "react-query"
import { getAutoSuggestions } from "../../../api"
import { LocalesContext } from "../../../context"
import { HeaderContext } from "../../Header/context/HeaderContext"
import { queryStaleTime } from "../../../constants"

interface AutoSuggestProps {
	query: string
	isSearchPopup: boolean
	showPopup?: React.Dispatch<React.SetStateAction<boolean>>
}
interface AutoSuggestionResponse {
	suggestion: string
	type: string
}

const AutoSuggest: React.FC<AutoSuggestProps> = ({ query, isSearchPopup }) => {
	const { translate, translationKeys } = React.useContext(LocalesContext)
	const { setShowSearchPopup } = React.useContext(HeaderContext)
	const [expandAutoSuggestions, setExpandAutoSuggestions] =
		React.useState<boolean>(false)
	const { data } = useQuery<AutoSuggestionResponse[]>(
		`suggest-${query}`,
		() => getAutoSuggestions(query),
		{
			staleTime: queryStaleTime,
		}
	)

	React.useEffect(() => {
		if (data?.length > 0) setExpandAutoSuggestions(true)
	}, [data])

	return (
		<>
			{expandAutoSuggestions && (
				<>
					{!isSearchPopup && (
						<Flex
							as="button"
							w="100vw"
							h="100vh"
							position="fixed"
							top="0"
							left="0"
							zIndex={5}
							onClick={() => setExpandAutoSuggestions(false)}
							tabIndex={-1}
						></Flex>
					)}
					<Flex
						w={1}
						maxw={{ _: 1, m: 69 }}
						mx="auto"
						flexDirection="column"
						p={isSearchPopup ? 0 : 3}
						mt={isSearchPopup && 3}
						backgroundColor="white"
						borderRadius="0 0 8px 8px"
						border={!isSearchPopup}
						borderTop={false}
						zIndex={10}
					>
						<Flex w={1} borderBottom mb={2} borderColor="blue33">
							<Text fontWeight="bold" mb={0}>
								{translate(translationKeys.suggestion).toLocaleUpperCase()}
							</Text>
						</Flex>
						<Flex as="ul" flexDirection="column" rowGap={2}>
							{data?.map((item: AutoSuggestionResponse) => {
								return (
									<Flex as="li" key={`auto-suggestion-${item.suggestion}`}>
										<Text.Link
											mb={0}
											to={`/sok?query=${item.suggestion}`}
											onClick={() => {
												isSearchPopup && setShowSearchPopup(false)
											}}
										>
											{item.suggestion}
										</Text.Link>
									</Flex>
								)
							})}
						</Flex>
					</Flex>
				</>
			)}
		</>
	)
}

export { AutoSuggest }
